module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.7ca4c310.png";